import { render, staticRenderFns } from "./FreeTrialSwiperOSContainer.vue?vue&type=template&id=f96226da&scoped=true"
import script from "./FreeTrialSwiperOSContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./FreeTrialSwiperOSContainer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FreeTrialSwiperOSContainer.vue?vue&type=style&index=0&id=f96226da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96226da",
  null
  
)

export default component.exports